export default __webpack_public_path__ + "static/media/Strata.8a007a68.svg";